export default {
  menu: {
    sports: "스포츠",
    referAndEarn: "추천하고 수익 얻기",
    referDesc: "최대 60% 커미션",
    copyLink: "링크 복사",
    hot: "인기",
    favorites: "즐겨찾기",
    recent: "최근",
    vipClub: "VIP 클럽",
    bonus: "보너스",
    bonusGames: "보너스 게임",
    affiliate: "제휴",
    promotion: "프로모션",
    rewards: "보상",
    help: "도움말",
    feedback: "피드백",
    downloadApp: "앱 다운로드",
    claimBonus: "보너스 받기",
    redeemCode: '코드 교환',
    redeemDesc: '무료 보상을 받으세요',
    liveSupport: "실시간 지원",
    language: "언어",
	search: "search"
  }
}
